import { render, staticRenderFns } from "./edit-business.component.html?vue&type=template&id=0f327b90&scoped=true&external"
import script from "./edit-business.component.ts?vue&type=script&lang=ts&external"
export * from "./edit-business.component.ts?vue&type=script&lang=ts&external"
import style0 from "./edit-business.component.scss?vue&type=style&index=0&id=0f327b90&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f327b90",
  null
  
)

export default component.exports